import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {Role, RoleEntity} from "../../../model/role";

export interface RoleSelectorProps {

}

export const rolesSelector = () => createSelector(
  [getUseQueryResultData<Role[]>],
  (data) => {
    return selectRolesAndTransform(
      data ?? [], {}
    );
  }
);

export const roleSelector = () => createSelector(
  [getUseQueryResultData<Role>],
  (data) => {
    return data ? transformRole(data) : undefined;
  }
);

export const selectRoles = (values?: Role[], selector?: RoleSelectorProps): Role[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    return filterIn;
  });
};

export const transformRole = (value: Role): RoleEntity => {
  return RoleEntity.from(value)
}

export const selectRolesAndTransform = (values?: Role[], selector?: RoleSelectorProps): RoleEntity[] => {
  const selected = selectRoles(values, selector);
  return selected.map(transformRole);
};
